import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';
import {
  isTerminalPublishStatus,
  type PublishJob,
  type PublishJobResponse
} from '@utils/types/publishing/publish.ts';

async function fetchPublishJob(jobId: string): Promise<PublishJob> {
  const { data } = await Axios.get<PublishJobResponse>(
    GET_URL(jobId).publishJob
  );
  return data.result;
}

/**
 * Poll the backend for a running publish job. Stops polling as soon as
 * the job reaches a terminal state so a user who leaves the dialog
 * open on a succeeded job does not keep hitting the API.
 */
export function useGetPublishJob(jobId: string | null) {
  return useQuery<PublishJob>(
    QueryKeys.publishJob(jobId ?? '__none__'),
    () => fetchPublishJob(jobId as string),
    {
      enabled: !!jobId,
      refetchInterval: data =>
        data && isTerminalPublishStatus(data.status) ? false : 2000,
      refetchIntervalInBackground: true,
      useErrorBoundary: false
    }
  );
}
